import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const Footer = () => {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API_BASE}/api/settings`);
        setSettings(response.data);
      } catch (error) {
        // Use defaults if API fails
      }
    };
    fetchSettings();
  }, []);

  const footerText = settings.footer_text?.value || 'CopyRight Sanjivanee Saving and Credit Co-operative Ltd';
  const maintainedBy = settings.maintained_by?.value || 'Pritam Rauniyar';
  const maintainedByUrl = settings.maintained_by_url?.value || 'https://pritamrauniyar.com.np/';

  return (
    <footer>
      <p>
        {footerText}
        {' | Maintained By '}
        <a href={maintainedByUrl} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'white'}}>
          {maintainedBy}
        </a>
      </p>
    </footer>
  );
};

export default Footer;
